module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "CT-VERSO"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("“Remember, there’s a chemical in the pool that turns pee blue—"), _c('span', {
    staticClass: "txbf1"
  }, [_vm._v("so we’ll all know")]), _vm._v("!”")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "COT"
  }, [_vm._v("If you saw the Adam Sandler movie "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Grown Ups")]), _vm._v("—well, first of all, I’m very sorry, but second, you may remember the scene in which Kevin James, swimming at a water park, reassures his daughter that the pool chemical that turns urine dark blue is “an old wives’ tale.” Pull back to reveal: big clouds of dark blue emanating from the trunks of "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("all five")]), _vm._v(" of the dads! I’m laughing already!")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But you should believe Kevin James’s dialogue and not his sight gags. Parents have been telling their kids since at least the 1950s that "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("everyone will know")]), _vm._v(" if they whiz in the pool, but this is a Santa-level cover-up. “You are speaking of a product that is an urban legend,” a pool expert told "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("New York")]), _vm._v(" magazine in 2010. “There is no such product available.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Anyone who took high school chemistry has used pH indicators, substances that dramatically change color in the presence of acid or alkaline substances. But these indicators won’t work for urine. Your “pee-H” varies widely from acidic to alkaline depending on diet, time of day, and other factors. Urine is mostly water anyway, and the other stuff it contains (urea, salt, creatinine) is found in sweat as well, so science will probably never devise a urine indicator that’s a surefire smoking, er, gun. Orson Welles told one biographer that in 1937, he and writer Charles MacArthur bought from a local chemist a colorless liquid that produced “raspberry-colored clouds” in the presence of pee, mortifying the guests at his pool parties. But given the unlikelihood of such a compound existing, we must conclude that Welles was, as impresarios are prone to do, spinning a yarn for comic effect.")])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("The real problem with a pee detector is that busy municipal pools would probably be the urine-positive color all the time. A 2009 survey by the Water Quality and Health Council found that 17 percent of American adults admit to peeing in the pool. Imagine how high that number is for kids! Even nineteen-time gold medal winner Michael Phelps once admitted to Jimmy Kimmel that he’s been known to ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("micturate in the natatorium.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("“Which nationality pees in the pool the most?” Kimmel wanted to know.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Probably Americans,” Phelps admitted.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("We’re number one! We’re number one!")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "height": "18",
      "src": "images/white.jpg",
      "width": "120"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TF"
  }, [_vm._v("FALSE.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-721179a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch05.vue
// module id = 87
// module chunks = 0